module.exports = __webpack_public_path__ + "static/media/swan.fa1deadf.svg";